package ar.corzo.health_tracker.connections

import ar.corzo.firebase.getToken
import io.ktor.client.HttpClient
import io.ktor.client.engine.HttpClientEngineConfig
import io.ktor.client.engine.HttpClientEngineFactory
import io.ktor.client.plugins.auth.Auth
import io.ktor.client.plugins.auth.providers.BearerTokens
import io.ktor.client.plugins.auth.providers.bearer

expect val engineClient: HttpClientEngineFactory<HttpClientEngineConfig>

val authClient = HttpClient(engineClient) {
    install(Auth) {
        bearer {
            loadTokens {
                getToken()?.let{
                    BearerTokens(it, null)
                }
            }
        }
    }
}

//const val serverBase = "http://localhost"
const val serverBase = "https://health-tracker-128515194935.southamerica-west1.run.app"